import {Component, Input} from '@angular/core';


interface StatusOption {
    status: string;
    pretty_title: string;
    icon: string;
    description: string;
}

@Component({
    selector: 'src-job-status',
    templateUrl: './job-status.component.html',
    styleUrls: ['./job-status.component.scss'],
    imports: [],
    standalone: true
})
export class JobStatusComponent {

    private status_options: StatusOption [] = [
        {status: 'pending', pretty_title: "Pending", description: "Job status is pending", icon: "pending"},
        {status: 'processing', pretty_title: "In Progress", description: "Job status is in progress", icon: "settings_b_roll"},
        {status: 'completed', pretty_title: "Completed", description: "Job status is completed", icon: "check_circle"},
        {status: 'error', pretty_title: "Error", description: "Job status is error", icon: "error"},
    ];

    status_option: StatusOption;

    @Input()
    set status(value: string) {
        this.status_option = this.status_options.find((o) => o.status == value);
    }
}
